import { render, staticRenderFns } from "./ContractorsSettings.vue?vue&type=template&id=393e2f7c&scoped=true&"
import script from "./ContractorsSettings.vue?vue&type=script&lang=js&"
export * from "./ContractorsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393e2f7c",
  null
  
)

export default component.exports